<!-- Popup for global file upload (add data button in center of screen) -->
<div class="fdm-dialog fdm-fade" id="panel-upload-simple">
  <div class="fdm-overlay-full" (click)="dialogRef.close()"></div>

  <mat-card class="fdm-dropdown-panel">

    <!-- Add data -->
    <mat-card-header class="header">
      <div class="subheading-2 title">{{ 'MAP.ADD_DATA' | translate }}</div>
      
      <div class="header-actions">
        
        <!-- Close dialog -->
        <fa-icon class="fdm-link" icon="times" style="font-size:22px;margin-right:5px;" 
        (click)="dialogRef.close()"></fa-icon>
      
      </div>
    </mat-card-header>

    <!-- Drag/drop files -->
    <mat-card-content class="fdm-drag-drop-section">

      <div class="container upload-sections">
        
        <div [class]="'col-'+(permissions?.can?.see_import_export?.library?4:6)">
          <h4 translate>MAP.LABEL_UPLOAD</h4>
          
          <section class="fdm-section-promote">
            
            <button mat-raised-button class="fdm-button-feature" (click)="fileInput1.click()">
              <fa-icon icon="file-upload"></fa-icon>
            </button>

            <!-- Upload from your computer -->
            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.UPLOAD_FILES</div>
            <input hidden multiple="multiple" type="file" (change)="mainService.uploadFiles($event);dialogRef.close();" #fileInput1 id="fileInput1">
          
          </section>

          <!-- Import from Dropbox -->
          <section class="fdm-section-promote">
            <button (click)="mainService.pickDropbox();dialogRef.close()"  mat-raised-button class="fdm-button-feature">
              <fa-icon  [icon]="['fab','dropbox']"></fa-icon>
            </button>

            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>FILE_LIST.NAV.DROPBOX</div>
          </section>

          <div style="color:#999;font-size:14px;" translate>GENERIC.OR</div>

          <!-- Drag your files here -->
          <div class="fdm-drag-drop-zone" (drop)="mainService.dropFile($event);dialogRef.close();" style="margin-top:15px;"
          (dragover)="dragOver($event)" [ngClass]="{'fdm-drag-drop-zone-hover':mainService.isOver}"
          (dragenter)="mainService.isOver = true;helloDrop($event,true)" (dragleave)="helloDrop($event,false)">
        <fa-icon icon="cloud-upload"></fa-icon>
        <div translate>MAP.DRAG_FILES</div>
      </div>

        </div>

        <div [class]="'col-'+(permissions?.can?.see_import_export?.library?4:6)" style="border-left:dotted 1px #ccc;border-right:dotted 1px #ccc;">
          <h4 translate>MAP.LABEL_UPLOADED</h4>
          <section class="fdm-section-promote">
            <button (click)="mainService.uploadExistingFiles.next();dialogRef.close()" mat-raised-button class="fdm-button-feature">
              <fa-icon icon="folder-tree"></fa-icon>
            </button>

            <!-- Add from existing data -->
            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.EXISTING_DATA</div>
          </section>

          <!-- 
            * If we can open a dialog tree component to the Demo section, uncomment and configure this one
          <section class="fdm-section-promote">
            <button (click)="mainService.uploadExistingFiles.next();dialogRef.close()" mat-raised-button class="fdm-button-feature">
              <fa-icon icon="folder-tree"></fa-icon>
            </button>
            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.EXISTING_DATA_DEMO</div>
          </section>
          -->
        </div>

        <div class="col-4" *ngIf="permissions?.can?.see_import_export?.library">
          <h4 translate>MAP.LABEL_EXTERNAL</h4>

          <!-- Add from WMS -->
          <section class="fdm-section-promote">
            <button (click)="importFromWMS();dialogRef.close()"  mat-raised-button class="fdm-button-feature">
              <fa-icon icon="cloud-upload-alt"></fa-icon>
            </button>
            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.WMS.UPLOAD</div>
          </section>

          <!-- Add a data feed -->
          <section class="fdm-section-promote" style="display:none">
            <button (click)="toggleShowDataFeed()"  mat-raised-button class="fdm-button-feature">
              <fa-icon  icon="rss-square"></fa-icon>
            </button>
            <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.WMS.DATA_FEED</div>
            <div *ngIf="showAddDataFeed" id="addDataFeed">
              <h3>
                {{ 'MAP.WMS.DATA_FEED' | translate }}
                <fa-icon class="fdm-link" icon="times" class="fdm-link float-right" style="font-size:22px;margin-right:5px;" (click)="toggleShowDataFeed()"></fa-icon>
              </h3>
              <div class="content">
                <table *ngIf="fakeFile">
                  <tr>
                    <td>{{ 'FILE_LIST.HEADING.name' | translate }}</td><td><input [(ngModel)]="fakeFile.name" name="name" /></td>
                  </tr>
                  <tr>
                    <td>{{ 'API.URL' | translate }}</td><td><input [(ngModel)]="fakeFile.url" name="url" /></td>
                  </tr>
                  <tr>
                    <td>{{ 'API.USERNAME' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td><input [(ngModel)]="fakeFile.username" name="username" /></td>
                  </tr>
                  <tr>
                    <td>{{ 'API.PASSWORD' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td><input type="password" [(ngModel)]="fakeFile.password" name="password" /></td>
                  </tr>
                </table>
                <button (click)="toggleShowDataFeed();uploadFakeFile()"  mat-raised-button color="primary">
                  <fa-icon icon="cloud-download-alt"></fa-icon> {{ 'MAP.ADD_DATA' | translate }}
                </button>
              </div>
            </div>
          </section>
        </div>

      </div>

<!-- 

  * Old version; keep it hidden for now, and let's kill it when the new is ready (just here for reference for now)

  

      <div class="fdm-drag-drop-zone" (drop)="mainService.dropFile($event);dialogRef.close();"
          (dragover)="dragOver($event)" [ngClass]="{'fdm-drag-drop-zone-hover':mainService.isOver}"
          (dragenter)="mainService.isOver = true;helloDrop($event,true)" (dragleave)="helloDrop($event,false)">
        <fa-icon icon="cloud-upload"></fa-icon>
        <div translate>MAP.DRAG_FILES</div>
      </div>

      <div class="fdm-section fdm-centered container">
        !-- Upload files from PC --
        <div class="col-3">
          <button mat-raised-button class="fdm-button-feature" (click)="fileInput1.click()">
            <fa-icon icon="file-upload"></fa-icon>
          </button>
          <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.UPLOAD_FILES</div>
          <input hidden multiple="multiple" type="file" (change)="mainService.uploadFiles($event);dialogRef.close();" #fileInput1 id="fileInput1">
        </div>

        !-- Add from existing data --
        <div class="col-3">
          <button (click)="mainService.uploadExistingFiles.next();dialogRef.close()" mat-raised-button class="fdm-button-feature">
            <fa-icon icon="folder-tree"></fa-icon>
          </button>
          <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.EXISTING_DATA</div>
        </div>

        !-- Add a data feed --
        <div class="col-3">
          <button (click)="toggleShowDataFeed()"  mat-raised-button class="fdm-button-feature">
            <fa-icon  icon="rss-square"></fa-icon>
          </button>
          <div style="color:#999;font-size:12px;padding:5px 15px;" translate>MAP.DATA_FEED</div>

          <div *ngIf="showAddDataFeed" id="addDataFeed">
            <h3>
              {{ 'MAP.DATA_FEED' | translate }}
              <fa-icon icon="times" class="float-right" style="font-size:22px;margin-right:5px;" (click)="dialogRef.close()"></fa-icon>
            </h3>

            <div class="content">
              <table *ngIf="fakeFile">
                <tr>
                  <td>{{ 'FILE_LIST.HEADING.name' | translate }}</td><td><input [(ngModel)]="fakeFile.name" name="name" /></td>
                </tr>
                <tr>
                  <td>{{ 'API.URL' | translate }}</td><td><input [(ngModel)]="fakeFile.url" name="url" /></td>
                </tr>
                <tr>
                  <td>{{ 'API.USERNAME' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td><input [(ngModel)]="fakeFile.username" name="username" /></td>
                </tr>
                <tr>
                  <td>{{ 'API.PASSWORD' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td><input type="password" [(ngModel)]="fakeFile.password" name="password" /></td>
                </tr>
              </table>
              <button (click)="toggleShowDataFeed();uploadFakeFile()"  mat-raised-button color="primary">
                <fa-icon icon="cloud-download-alt"></fa-icon> {{ 'MAP.ADD_DATA' | translate }}
              </button>
            </div>
          </div>
        </div>

        !-- Add from Dropbox --
        <div class="col-3">
          <button (click)="mainService.pickDropbox();dialogRef.close()"  mat-raised-button class="fdm-button-feature">
            <fa-icon  [icon]="['fab','dropbox']"></fa-icon>
          </button>
          <div style="color:#999;font-size:12px;padding:5px 15px;" translate>FILE_LIST.NAV.DROPBOX</div>
        </div>
      </div>
      -->

      
    </mat-card-content>
  </mat-card>
</div>
